import { inject, Injectable } from '@angular/core';
import { Observable, catchError, from, throwError } from 'rxjs';
import {
  CreateTagRequest,
  TagList,
  TagResponse,
  TagsApi,
  UpdateTagRequest,
} from '@tourfold/libraries/tf-api-client-public-v2';

@Injectable({
  providedIn: 'root',
})
export class TagsService {
  private readonly tagsApi = inject(TagsApi);

  getTags(page = 0, size = 200): Observable<TagList> {
    return from(this.tagsApi.getTags({ page, size })).pipe(
      catchError((error) => {
        return throwError(() => error);
      }),
    );
  }

  createTag(createTagRequest: CreateTagRequest): Observable<TagResponse> {
    return from(this.tagsApi.createTag({ createTagRequest })).pipe(
      catchError((error) => {
        return throwError(() => error);
      }),
    );
  }

  updateTag(id: string, updateTagRequest: UpdateTagRequest): Observable<TagResponse> {
    return from(this.tagsApi.updateTag({ id, updateTagRequest })).pipe(
      catchError((error) => {
        return throwError(() => error);
      }),
    );
  }

  deleteTag(id: string): Observable<void> {
    return from(this.tagsApi.deleteTag({ id })).pipe(
      catchError((error) => {
        return throwError(() => error);
      }),
    );
  }
}
